import React from "react";
import Box from "@mui/material/Box";
import Container from "../../common/Container";
import Header from "../../components/Header";
import AppBar from "@mui/material/AppBar";
import Footer from "../../components/Footer";
import Gallery from "./components/Gallery";
import Scroll from "../Header/Scroll";
import Banner from "./components/Banner";
import Whatsapp from "../Footer/Whatsapp";

const Portfolio = () => {
  return (
    <Box>
      <Scroll>
        <AppBar
          position={"fixed"}
          elevation={0}
          sx={{
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box bgcolor={"#000"}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Container>
          <Gallery />
        </Container>
      </Box>
      <Box bgcolor={"#000"}>
        <Container>
          <Footer />
        </Container>
      </Box>
      <Whatsapp/>
    </Box>
  );
};

export default Portfolio;
